(function () {
  var config = window.taminzoConfig || {};
  var API_BASE = config.apiBase || 'https://sellers-be.taminzo.com';
  var country = (config.country || 'PK').toUpperCase();
  var SESSION_KEY = 'taminzo_seen_products';
  var FLUSH_MS = 4000;

  // --- session dedup ---
  function getSeenProducts() {
    try { return new Set(JSON.parse(sessionStorage.getItem(SESSION_KEY) || '[]')); }
    catch (e) { return new Set(); }
  }
  function markSeen(productId) {
    var seen = getSeenProducts();
    seen.add(String(productId));
    try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(Array.from(seen))); } catch (e) {}
  }
  function alreadySeen(productId) {
    return getSeenProducts().has(String(productId));
  }

  // --- event queue + flush ---
  var queue = [];

  function enqueue(shopifyProductId, eventType) {
    queue.push({ shopifyProductId: String(shopifyProductId), eventType: eventType });
  }

  function flush() {
    if (queue.length === 0) return;
    var batch = queue.splice(0, queue.length);
    var payload = JSON.stringify({ country: country, events: batch });
    fetch(API_BASE + '/api/impressions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: payload,
      keepalive: true
    }).catch(function () {});
  }

  setInterval(flush, FLUSH_MS);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });

  // --- Intersection Observer — card impressions ---
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var productId = entry.target.dataset.productId;
      if (!productId || alreadySeen(productId)) return;
      markSeen(productId);
      observer.unobserve(entry.target);
      enqueue(productId, 'card_impression');
    });
  }, { threshold: 0.5 });

  function observeCards() {
    document.querySelectorAll('[data-product-id]').forEach(function (el) {
      if (!alreadySeen(el.dataset.productId)) observer.observe(el);
    });
  }

  observeCards();

  // re-observe after dynamic content (quick-add, section rendering, boost injection)
  new MutationObserver(observeCards).observe(document.body, { childList: true, subtree: true });

  // --- PDP product view ---
  var meta = window.statsigConfig && window.statsigConfig.pageMeta;
  if (meta && meta.page_type === 'product' && meta.product_id) {
    var key = 'taminzo_pdp_' + meta.product_id;
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      enqueue(meta.product_id, 'product_view');
    }
  }

  // expose observeCards so taminzo-boost.js can call it after injection
  window.taminzoPixel = { observeCards: observeCards };
})();
